import './didot/Didot.ttf';
import './didot/Didot-Italic.ttf';
import './didot/Linotype - Didot LT Pro Bold.ttf';



// WEBPACK FOOTER //
// ./fonts/index.js